import React from 'react';
import { Link } from 'react-router-dom';
import { FiClock, FiTag } from '../Icons';
import { Article } from '../../types';

interface ArticleCardProps {
  article: Article;
}

const ArticleCard: React.FC<ArticleCardProps> = ({ article }) => {
  return (
    <Link
      to={`/articles/${article.category}/${article.slug}`}
      className="block bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-200 p-6"
    >
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {article.title}
      </h3>
      <p className="text-gray-600 text-sm mb-4 line-clamp-2">
        {article.description}
      </p>
      <div className="flex items-center justify-between text-xs text-gray-500">
        <div className="flex items-center space-x-4">
          {article.readTime && (
            <span className="flex items-center space-x-1">
              <FiClock className="h-3 w-3" />
              <span>{article.readTime} min read</span>
            </span>
          )}
          <span className="flex items-center space-x-1">
            <FiTag className="h-3 w-3" />
            <span>{article.category}</span>
          </span>
        </div>
        <span className="text-blue-600 font-medium">
          Read more →
        </span>
      </div>
    </Link>
  );
};

export default ArticleCard;